// @flow

import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-block;
  padding: 6px 16px;
  background: ${props => props.theme.colors.neutral[100]};
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral[600]};
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;
